'use client';

import * as React from 'react';
import { type VariantProps } from 'class-variance-authority';

import { buttonVariants } from './Button.variants';
import { cn } from '../../utils/cn/cn';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants>;

const Button = ({ className, color, variant, size, type, children, ...props }: ButtonProps) => (
  <button
    {...props}
    type={type === 'submit' ? 'submit' : 'button'}
    className={cn(buttonVariants({ variant, color, size }), className)}
  >
    {children}
  </button>
);

export type ButtonLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  VariantProps<typeof buttonVariants> & {
    LinkComponent: React.ElementType;
    ref: React.RefObject<any>;
  };

/**
 * A link that looks like a button.
 * You can also pass a custom Link component via the prop LinkComponent.
 */
const ButtonLink = ({
  className,
  color,
  variant,
  size,
  type,
  children,
  LinkComponent = 'a',
  ...props
}: ButtonLinkProps) => (
  <LinkComponent {...props} className={cn(buttonVariants({ variant, color, size }), className)}>
    {children}
  </LinkComponent>
);

export { Button, ButtonLink };
